import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/company', { params }),
  create: params => axios.post('/api/v1/avg/company', params),
  update: params => axios.put(`/api/v1/avg/company/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/company', { params })
};
